import { useEffect, useState } from "react";
import { api, resolveImage } from "@/lib/api";

/**
 * Home-page floating product A/B — rotates between Cherry Bomb and Freshly
 * Baked deterministically by UTC day. Returns { variant, product, image, loading }.
 *
 * Fires a `view` event on mount (idempotent per cart_id via the caller passing
 * a stable cart_id). Exposes `trackClick()` for the caller to fire when the
 * user taps the product.
 */
export function useHeroProduct(cartId) {
  const [state, setState] = useState({ variant: null, product: null, loading: true });

  useEffect(() => {
    let cancelled = false;
    api.get("/hero-product/current")
      .then((r) => {
        if (cancelled) return;
        setState({ variant: r.data.variant, product: r.data.product, loading: false });
        // fire-and-forget view
        api.post("/hero-product/track", { event: "view", variant: r.data.variant, cart_id: cartId })
          .catch(() => {});
      })
      .catch(() => setState((s) => ({ ...s, loading: false })));
    return () => { cancelled = true; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const trackClick = () => {
    if (!state.variant) return;
    api.post("/hero-product/track", { event: "click", variant: state.variant, cart_id: cartId })
      .catch(() => {});
  };

  const image = state.product ? resolveImage(state.product.image_url, 900, { removeBg: true }) : null;
  return { ...state, image, trackClick };
}
